import { render, staticRenderFns } from "./form-body.vue?vue&type=template&id=264d2b06"
import script from "./form-body.vue?vue&type=script&lang=js"
export * from "./form-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports